module.exports = __webpack_public_path__ + "static/media/font.4c19fc87.ttf";